<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h3>Brake Metals Finish Catalog</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-text-field
                        v-model.trim="item.finish"
                        hide-details="auto"
                        prepend-icon="mdi-format-list-bulleted-type"
                        label="Finish *"
                        :rules="[rules.requiredStr]"
                        dense
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
                <v-col cols="12">
                    <v-text-field
                        v-model.trim="item.finishClass"
                        hide-details="auto"
                        prepend-icon="mdi-format-list-bulleted"
                        label="Finish class *"
                        :rules="[rules.requiredStr]"
                        dense
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                rounded
                :loading="loading"
                @click="save"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import { objDiff } from '@/helpers/objDiff.js'
import API from '@/services/api'

export default {
    name: 'FinishFormBrakeMetalsCatalog',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: false,
        },
        setting: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            rules: {
                requiredStr: v =>
                    v !== null && v !== undefined && String(v).trim() !== ''
                        ? true
                        : 'Requerido',
            },
        }
    },
    computed: {
        itemDiff() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            }
            return null
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        isInvalid() {
            return !this.item.finish || !this.item.finishClass
        },
        async save() {
            if (this.isInvalid()) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: 'Complete finish y finish class',
                })
                return
            }
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        async create() {
            try {
                this.loading = true
                const created = await API.createFinishBrakeMetalsCatalog({
                    settingId: this.setting.id,
                    finish: String(this.item.finish || '').trim(),
                    finishClass: String(this.item.finishClass || '').trim(),
                })
                this.$emit('addItem', created)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const patch = this.itemDiff || {}
                if (Object.keys(patch).length === 0) {
                    this.$emit('close')
                    return
                }
                const updated = await API.updateFinishBrakeMetalsCatalog({
                    settingId: this.setting.id,
                    id: this.item.id,
                    ...patch,
                })
                this.$emit('replaceItem', updated)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>
